import { lazy } from 'react';

import { routes } from '@/constants/Constants';

const ApplicationsOverviewRoute = lazy(() => import('./routes/applications-overview.route'));
const RenewalCollectionRoute = lazy(() => import('./routes/renewal-collection.route'));
const LegacyDealsDashboardRedirectRoute = lazy(
  () => import('./routes/legacy-deals-dashboard-redirect.route'),
);
const RenterInviteRedirectRoute = lazy(() => import('./routes/renter-invite-redirect.route'));
const RenterInviteConfirmationRedirectRoute = lazy(
  () => import('./routes/renter-invite-confirmation-redirect.route'),
);

export const applicationTrackerRoutes = [
  {
    path: routes.dealsDashboard,
    component: ApplicationsOverviewRoute,
    title: 'Application Tracker | TheGuarantors',
  },
  {
    path: routes.renewalIntentCollect,
    component: RenewalCollectionRoute,
    title: 'Confirm lease renewal | TheGuarantors',
    handle: {
      hasBreadcrumbs: true,
      hideFooter: true,
    },
  },
  {
    path: routes.dealsDashboardRedirectLink,
    component: LegacyDealsDashboardRedirectRoute,
    title: 'Application Tracker | TheGuarantors',
  },
  {
    path: routes.renterInvite,
    component: RenterInviteRedirectRoute,
    title: 'Invite an applicant | TheGuarantors',
  },
  {
    path: routes.renterInviteConfirmation,
    component: RenterInviteConfirmationRedirectRoute,
    title: 'Applicant invited | TheGuarantors',
  },
];
